import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/Card';
import { Spinner } from '@/components/ui/Spinner';
import { EmptyState, NoDataIcon } from '@/components/ui/EmptyState';
import { usePremiumFlow } from '@/hooks/queries/useAnalytics';
import { PremiumFlowChart } from './PremiumFlowChart';

export function SymbolPremiumFlow({ symbol }: { symbol: string }) {
  const { data: flow, isLoading } = usePremiumFlow({ symbol });

  return (
    <Card>
      <CardHeader>
        <CardTitle>Premium Flow</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex items-center justify-center h-80"><Spinner /></div>
        ) : !flow || flow.collected === 0 ? (
          <div className="h-80 flex items-center justify-center">
            <EmptyState icon={<NoDataIcon />} title="No premium collected" description="No collected premium to trace for this symbol" />
          </div>
        ) : (
          <PremiumFlowChart flow={flow} />
        )}
      </CardContent>
    </Card>
  );
}
